export default __webpack_public_path__ + "static/media/arrow-bottom-blue.6a57f645.svg";